import { useState } from "react";
import textInputModel from "../../../models/general/elements/inputElements/textInput.model";
import TextInputElementComponent from "../../general/elements/inputElements/TextInputElementComponent";
import { useNavigate } from "react-router-dom";
import Quagga from "quagga";
import "../../../styles/layouts/header/_headerSearchComponent.scss";
import AlertService from "../../../services/alerts/alert.service";

export const HeaderSearchComponent = () => {
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState("");
  const [scanning, setScanning] = useState(false);

  const startScanning = async () => {
    setScanning(true);

    document.body.style.overflow = "hidden"; // 🔒 prevent scroll
    document.documentElement.style.overflow = "hidden";

    try {
      const stream = await navigator.mediaDevices.getUserMedia({ video: { facingMode: "environment" } });
      stream.getTracks().forEach((track) => track.stop());

      let scannerElement = document.getElementById("barcode-scanner");
      if (!scannerElement) {
        scannerElement = document.createElement("div");
        scannerElement.id = "barcode-scanner";
        scannerElement.className = "scanner-overlay";
        document.body.appendChild(scannerElement);
      }

      Quagga.init(
        {
          inputStream: {
            type: "LiveStream",
            constraints: { facingMode: "environment" },
            target: scannerElement,
          },
          decoder: { readers: ["ean_reader", "upc_reader", "code_128_reader"] },
          locate: true,
        },
        (err) => {
          if (err) {
            console.error("QuaggaJS Initialization Error:", err);
            alert("Camera initialization failed. Please check permissions.");
            setScanning(false);
            return;
          }
          Quagga.start();
        }
      );

      Quagga.onDetected((result) => {
        const barcode = result.codeResult.code;
        Quagga.stop();
        setScanning(false);
        setSearchQuery(barcode);
        navigate(`/search?query=${encodeURIComponent(barcode)}`);
      });
    } catch (error) {
      console.error("Camera access error:", error);
      AlertService("לא נמצאה מצלמה זמינה", "אנה השתמש במכשיר בו המצלמה זמינה או וודא כי ישנם הרשאות למצלמה באתר");
      setScanning(false);
    }
  };

  const stopScanning = () => {
    document.body.style.overflow = ''; // 🔓 re-enable scroll
    document.documentElement.style.overflow = '';
    
    Quagga.stop();
    setScanning(false);
    const scannerElement = document.getElementById("barcode-scanner");
    if (scannerElement) {
      scannerElement.remove();
    }
  };

  const handleSearch = (event) => {
    const { value } = event.target;
    setSearchQuery(value);
    if (!value) {
      navigate("/");
      return;
    }
    navigate(`/search?query=${encodeURIComponent(value)}`);
  };

  const getSearchInputElement = () => {
    const inputProps = {
      ...textInputModel,
      name: "searchQuery",
      value: searchQuery,
      placeholder: "חפש מוצר",
      onChange: handleSearch,
      icon: <i className="fa-solid fa-barcode" onClick={startScanning}></i>,
      customInputClass: "headerSearchInput",
      customDesignClass: "headerSearchContainer",
    };
    return <TextInputElementComponent props={inputProps} />;
  };

  return (
    <div className={`headerSearchContainer`}>
      {getSearchInputElement()}
      {scanning && (
        <div className="scanner-overlay">
          <button className="close-scanner" onClick={stopScanning}>
            ✖
          </button>
          <div className="focus-frame">
            <div></div> {/* Needed to support bottom corners */}
          </div>
          <div id="barcode-scanner"></div>
        </div>
      )}
    </div>
  );
};

export default HeaderSearchComponent;
// import { useState } from "react";
// import textInputModel from "../../../models/general/elements/inputElements/textInput.model";
// import TextInputElementComponent from "../../general/elements/inputElements/TextInputElementComponent";
// import { useNavigate } from "react-router-dom";
// import Quagga from "quagga";
// import "../../../styles/layouts/header/_headerSearchComponent.scss";
// import AlertService from "../../../services/alerts/alert.service";

// export const HeaderSearchComponent = () => {
//   const navigate = useNavigate();
//   const [searchQuery, setSearchQuery] = useState("");
//   const [scanning, setScanning] = useState(false);

//   const startScanning = async () => {
//     setScanning(true);

//     try {
//       const stream = await navigator.mediaDevices.getUserMedia({ video: { facingMode: "environment" } });
//       stream.getTracks().forEach((track) => track.stop());

//       let scannerElement = document.getElementById("barcode-scanner");
//       if (!scannerElement) {
//         scannerElement = document.createElement("div");
//         scannerElement.id = "barcode-scanner";
//         scannerElement.className = "scanner-overlay";
//         document.body.appendChild(scannerElement);
//       }

//       Quagga.init(
//         {
//           inputStream: {
//             type: "LiveStream",
//             constraints: { facingMode: "environment" },
//             target: scannerElement,
//           },
//           decoder: { readers: ["ean_reader", "upc_reader", "code_128_reader"] },
//           locate: true,
//         },
//         (err) => {
//           if (err) {
//             console.error("QuaggaJS Initialization Error:", err);
//             alert("Camera initialization failed. Please check permissions.");
//             setScanning(false);
//             return;
//           }
//           Quagga.start();
//         }
//       );

//       Quagga.onDetected((result) => {
//         const barcode = result.codeResult.code;
//         Quagga.stop();
//         setScanning(false);
//         setSearchQuery(barcode);
//         navigate(`/search?query=${encodeURIComponent(barcode)}`);
//       });
//     } catch (error) {
//       console.error("Camera access error:", error);
//       AlertService('לא נמצאה מצלמה זמינה', 'אנה השתמש במכשיר בו המצלמה זמינה או וודא כי ישנם הרשאות למצלמה באתר')
//       setScanning(false);
//     }
//   };

//   const stopScanning = () => {
//     Quagga.stop();
//     setScanning(false);
//     const scannerElement = document.getElementById("barcode-scanner");
//     if (scannerElement) {
//       scannerElement.remove();
//     }
//   };

//   const handleSearch = (event) => {
//     const { value } = event.target;
//     setSearchQuery(value);
//     if (!value) {
//       navigate("/");
//       return;
//     }
//     navigate(`/search?query=${encodeURIComponent(value)}`);
//   };

//   const getSearchInputElement = () => {
//     const inputProps = {
//       ...textInputModel,
//       name: "searchQuery",
//       value: searchQuery,
//       placeholder: "חפש מוצר",
//       onChange: handleSearch,
//       icon: <i className="fa-solid fa-barcode" onClick={startScanning}></i>,
//       customInputClass: "headerSearchInput",
//       customDesignClass: "headerSearchContainer",
//     };
//     return <TextInputElementComponent props={inputProps} />;
//   };

//   return (
//     <div className={`headerSearchContainer`}>
//       {getSearchInputElement()}
//       {scanning && (
//         <div className="scanner-overlay">
//           <button className="close-scanner" onClick={stopScanning}>✖</button>
//           <div id="barcode-scanner"></div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default HeaderSearchComponent;
